const { __, _x, _n, _nx } = wp.i18n;

/**
 * Implements high quality marking.
 */
var MarkHighQuality = ( function() {
	var C = function(){ return constructor.apply(this,arguments); };
	var p = C.prototype;

	function constructor( comment ) {
		var self = this;
		this.comment = comment;
		this.commentID = comment.id.match( /^comment-(\d+)$/ )[1];

		this.markLink = comment.querySelector( '.comment-mark-high-quality' );
		if ( this.markLink ) {
			let isHighQuality = this.markLink.dataset.isHighQuality == 'true';
			this.markLink.addEventListener(
				'click', this.handleMark.bind( this, ! isHighQuality ) );
		}
	};

	// Handle marking
	p.handleMark = function( isHighQuality ) {
		event.preventDefault();
		var self = this;

		this.markLink.innerHTML = this.markLink.dataset.loadingText;

		var jqxhr = jQuery.ajax( {
			url: wpApiSettings.root + 'iportal/v1/comment_high_quality_mark/'
				+ this.commentID,
			method: isHighQuality ? 'PUT' : 'DELETE',
			beforeSend: function( xhr ) {
				xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
			},
		} ).done( function( response ) {
			self.comment.querySelector( '.comment-content' ).classList.toggle( 'comment-content--high-quality' );
			self.markLink.outerHTML = self.markLink.dataset.savedText;
		} ).fail( function() {
			self.markLink.outerHTML = __( 'An error occured, please try again later', 'iportal-theme' );
		} );
	};

	return C;
} )();

export default MarkHighQuality;